__turbopack_context__.v({
  "dispatchText": "DispatchInfo-module__VVrz5W__dispatchText",
});
